<template>
  <div class="input-keypad">
    <div class="input-keypad__display">
      <div class="input-keypad__display-wrapper">
        <div class="display"><span>LOT</span>{{ displayValue }}</div>
      </div>
    </div>
    <div class="input-keypad__buttons">
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('1')">1</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('2')">2</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('3')">3</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('4')">4</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('5')">5</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('6')">6</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('7')">7</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('8')">8</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('9')">9</button>
      </div>
      <div class="input-keypad__button-wrapper">
        <button class="touch" @click="addToDisplay('0')">0</button>
      </div>
      <div class="input-keypad__button-wrapper input-keypad__button-wrapper--half">
        <button
          class="touch"
          :class="{ 'active': displayValue === value && value != '' }"
          @click="$emit('input', displayValue)"
        >
          Search
        </button>
      </div>
      <div class="input-keypad__button-wrapper input-keypad__button-wrapper--half">
        <button class="touch" @click="resetDisplay">Reset</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ 'value'],

  data () {
    return {
      displayValue: ''
    }
  },

  mounted () {
    this.displayValue = this.value
  },

  methods: {
    addToDisplay (value) {
      if (this.displayValue.length < 4) {
        this.displayValue += value
      }
    },

    resetDisplay (value) {
      this.displayValue = ''
      this.$emit('input', '')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.input-keypad {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 15rem;

  &__display {
    height: 3rem;
    margin: 0 -.2rem;

    .display {
      align-items: center;
      border: 0.1rem solid $white;
      border-radius: .5rem;
      display: flex;
      height: 100%;
      padding: .25rem 1rem 0;
      width: 100%;
    }

    span {
      font-weight: 100;
      margin: 0 .5rem 0 0;
    }
  }

  &__display-wrapper {
    display: flex;
    height: 3rem;
    padding: 0.2rem;
    width: 15rem;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -.2rem;
  }

  &__button-wrapper {
    font-size: 1.5rem;
    height: 3rem;
    padding: 0.2rem;
    width: 3rem;
    text-align: center;
    transition: background-color 0.15s ease-in;

    &--half {
      width: 7.5rem;
    }

    button {
      align-items: center;
      background: transparent;
      border: 0.1rem solid $white;
      border-radius: .5rem;
      display: flex;
      font-size: 1rem;
      font-weight: 100;
      justify-content: center;
      height: 100%;
      padding-top: .25rem;
      text-transform: uppercase;
      transition: background 50ms ease-out;
      width: 100%;

      &:active,
      &.active {
        background: $darklime;
      }
    }
  }
}
</style>

